import { render, staticRenderFns } from "./TableDisplaying.vue?vue&type=template&id=61645562&scoped=true"
import script from "./TableDisplaying.vue?vue&type=script&lang=ts"
export * from "./TableDisplaying.vue?vue&type=script&lang=ts"
import style0 from "./TableDisplaying.vue?vue&type=style&index=0&id=61645562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61645562",
  null
  
)

export default component.exports